import { Component } from '@angular/core';
import * as CountryApiActions from '@app/modules/countries/actions/country-api.actions';
import { CountryChangeSequenceModel } from '@app/modules/countries/models';
import * as Country from '@app/modules/countries/reducers';
import { ClaimTypes, ClaimValues } from '@app/shared/models/common/constants';
import { Store } from '@ngrx/store';
import { NzTableQueryParams } from 'ng-zorro-antd/table';

@Component({
	selector: 'app-country-overview',
	templateUrl: './country-overview.component.html',
	styleUrls: ['./country-overview.component.less'],
})
export class CountryOverviewComponent {
	tableData$ = this.store.select(Country.selectCountryOverviewState);

	ClaimTypes = ClaimTypes;
    ClaimValues = ClaimValues;

	constructor(private readonly store: Store) {}

	onDeleteConfirm(id: number): void {
		this.store.dispatch(CountryApiActions.Delete({ id: id }));
	}

	/**
	 * Trigger the loading of data whenever the table changes.
	 * The default pageSize, index and sort options are based on the TableStateModel.
	 * @param params
	 */
	onQueryParamsChange(params: NzTableQueryParams) {
		const { pageSize, pageIndex, sort, filter } = params;
		const currentSort = sort.find((item) => item.value !== null);
		const sortField = (currentSort?.key) ?? null;
		const sortOrder = (currentSort?.value) ?? null;

		this.store.dispatch(
			CountryApiActions.FilterOverview({
				pagination: {
					page: pageIndex,
					pageSize,
				},
				sorting: {
					propertyName: sortField ?? '',
					order: !!sortField ? (sortOrder === 'ascend' ? 'ASC' : 'DESC') : '',
				},
			})
		);
	}

	onResetOverview() {
        this.store.dispatch(CountryApiActions.ResetOverview());
    }

	onSequenceChange(request: CountryChangeSequenceModel) {
		this.store.dispatch(CountryApiActions.ChangeSequence(request));
	}
}
